export default __webpack_public_path__ + "static/usps2-63221a3ae1aa230ad976a34296215bfc.png";